interface ComputeTagSuggestionsArgs {
  readonly availableTags: readonly string[] | undefined;
  readonly currentTags: readonly string[];
  readonly inputValue: string;
  readonly isFocused: boolean;
  readonly limit?: number;
}

export function computeTagSuggestions({
  availableTags,
  currentTags,
  inputValue,
  isFocused,
  limit = 8,
}: ComputeTagSuggestionsArgs): string[] {
  if (!isFocused) return [];
  if (!availableTags || availableTags.length === 0) return [];

  const trimmed = inputValue.trim();
  const lower = trimmed.toLowerCase();
  const selected = new Set(currentTags);

  const matches = availableTags.filter(
    (t) => !selected.has(t) && (!trimmed || t.toLowerCase().includes(lower)),
  );
  return matches.slice(0, limit);
}
